import React from "react";
import { Tooltip, Button, Box } from "@mui/material";
import "./StitchChip.css";

const StitchChip = ({
  symbol,
  selected = false,
  onSelect,
  size = "medium",
}) => {
  const handleClick = () => {
    if (onSelect) {
      onSelect(symbol.symbol);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleClick();
    }
  };

  const tooltipContent = `${symbol.meaning} — ${symbol.description}`;

  return (
    <Tooltip
      title={tooltipContent}
      placement="bottom"
      enterDelay={300}
      leaveDelay={200}
    >
      <Button
        variant="stitch-chip"
        size={size === "cozy" ? "cozy" : "medium"}
        className={selected ? "stitch-chip--selected" : ""}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        aria-pressed={selected}
        aria-label={`${symbol.abbreviation} - ${symbol.meaning}`}
      >
        <Box className="stitch-chip__glyph">
          <Box component="span" className="stitch-chip__symbol">
            {symbol.symbol}
          </Box>
        </Box>
        <Box className="stitch-chip__divider"></Box>
        <Box className="stitch-chip__abbrev">{symbol.abbreviation}</Box>
      </Button>
    </Tooltip>
  );
};

export default StitchChip;
